import { css } from "styled-components";
import { fadeInAnimation } from "../../../../../sharable/Animations";
import { devices } from "../../../../../../Devices";

export const FloatWindowStyles = css`
  width: 32%;
  padding: 2.4rem;
  height: 50rem;
  background-color: #fff;
  position: fixed;
  z-index: 10;
  bottom: 5%;
  left: 1%;
  box-shadow: 0px 0px 50px 2px rgba(1, 1, 1, 0.1);
  border-radius: 10px;
  color: #444444;
  animation: ${fadeInAnimation} 0.2s linear;
  overflow-y: auto;
  .icon-wrapper {
    align-items: center;
    align-self: end;
    cursor: pointer;

    span,
    .icon {
      transition: all ease-in-out 200ms;
    }
  }

  .icon {
    align-self: end;
    color: black;
    font-size: 1.8rem;
  }

  .icon-wrapper:hover {
    .icon,
    span {
      color: #d97706;
    }
  }

  span {
    font-size: 1.4rem;
    text-align: center;
  }

  .edit-product-span {
    ont-size: 1.6rem;
    margin-top: 3.2rem;
  }

  h1 {
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-size: 3.6rem;
    font-weight: 600;
  }

  p {
    font-size: 1.2rem;
  }

  .promo-fields-list {
    margin-top: 2.4rem;
    gap: 1.4rem;
    width: 70%;
  }

  input {
    border: none;
    padding: 1.2rem 0 1.2rem 1rem;
    text-transform: capitalize;
    height: 4.2rem;
    background-color: #f5f5f5;
  }

  @media ${devices.tablet} {
    width: 90%;
    max-height: 100vh;
    left: 50%;
    transform: translateX(-50%);
  }

  .invalid-input {
    background-color: #ff7f7f !important;
  }

  .protective-layer {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    margin: -2.4rem;
    color: #ffffff;
  }

  ${({ isAccountPremium }) =>
    !isAccountPremium &&
    css`
      .close-advanced-fields,
      .icon {
        color: #ffffff;
        z-index: 11;
      }
    `}
`;
